import { useEffect, useRef, useState } from "react";

export const HeroTitle = ({ a, b }) => {
  const text = useRef(null);
  const [h, setH] = useState(null);
  useEffect(() => {
    const ro = new ResizeObserver(([e]) => setH(e.contentRect.height));
    ro.observe(text.current);
    return () => ro.disconnect();
  }, []);
  return (
    <div data-testid="hero-title" role="presentation" className="font-display text-4xl sm:text-6xl leading-[0.95] mb-6 flex items-center gap-4 sm:gap-6">
      <span data-testid="hero-ai-logo-wrap" className="ai-logo relative shrink-0 inline-block max-w-[30%]">
        <img data-testid="hero-ai-logo" src="/brand/ai-head.webp" alt="Aurora-ADV intelligenza artificiale"
          style={{ height: h || "1.9em" }} className="block w-auto max-w-full object-contain transition-[height] duration-300" />
        <span aria-hidden="true" style={{ "--logo-mask": "url(/brand/ai-head.webp)" }} className="ai-logo-light absolute inset-0 pointer-events-none" />
      </span>
      <span ref={text} className="block min-w-0">
        <span className="block">{a}</span>
        <span className="block aurora-text">{b}</span>
      </span>
    </div>
  );
};
